import {
  Box,
  Chip,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import { LLMQNLIResponse } from "../../../../types/llm";

interface ResultsProps {
  results: LLMQNLIResponse | undefined;
}

const Results = (props: ResultsProps): ReactElement => {
  const { results } = props;

  if (!results) {
    return <></>;
  }

  const scorePercent = Math.round(results.score * 100);
  const isEntailment = results.label === "LABEL_0";
  const labelText = isEntailment ? "Entails" : "Does not entail";

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Result
        </Typography>

        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Model
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {results.model}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Label
          </Typography>
          <Box sx={{ marginTop: 0.5 }}>
            <Chip
              label={results.label + " · " + labelText}
              color={isEntailment ? "success" : "default"}
              variant={isEntailment ? "filled" : "outlined"}
              sx={{ fontWeight: 700 }}
            />
          </Box>
        </Box>

        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: 1 }}
          >
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Score
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {scorePercent}%
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={scorePercent}
            sx={{ height: 8, borderRadius: 1 }}
          />
        </Box>
      </Stack>
    </Paper>
  );
};

export default Results;
